import { render, staticRenderFns } from "./assetsStatisticsDetail.vue?vue&type=template&id=10199618&scoped=true"
import script from "./assetsStatisticsDetail.vue?vue&type=script&lang=js"
export * from "./assetsStatisticsDetail.vue?vue&type=script&lang=js"
import style0 from "./assetsStatisticsDetail.vue?vue&type=style&index=0&id=10199618&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10199618",
  null
  
)

export default component.exports